import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { isLoggedInAtom, userReceivedAction } from '@root/entities/auth'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import {
  assignTelegramRequestAction,
  unassignTelegramRequestAction,
} from './telegram-requests'

import type { OAuthCode, TelegramAuthToken } from '@root/entities/auth'

export const assignTelegramAction = action(
  async (
    ctx,
    { tgToken, authCode }: { tgToken: TelegramAuthToken; authCode: OAuthCode },
  ) => {
    const isLoggedIn = ctx.get(isLoggedInAtom)
    if (!isLoggedIn) {
      return
    }

    const result = await ctx.schedule(() =>
      assignTelegramRequestAction(ctx, { authCode, token: tgToken }),
    )

    if (Result.isSuccess(result)) {
      showSnackbarAction(ctx, {
        text: i18next.t('settings.telegram.success'),
        intent: 'success',
      })
      userReceivedAction(ctx, result.success)
    } else {
      showSnackbarAction(ctx, {
        text: i18next.t('settings.telegram.connect-error'),
        description: i18next.t('common.something_went_wrong_try_again'),
        intent: 'error',
      })
    }
  },
  'assignTelegramAction',
)

export const reatomUnassignTelegram = () => {
  return reatomRequest({
    execAction: unassignTelegramRequestAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'reatomUnassignTelegram',
    onResult: (ctx, result) => {
      if (Result.isSuccess(result)) {
        showSnackbarAction(ctx, {
          text: i18next.t('settings.telegram.unassign-success'),
          intent: 'success',
        })
        userReceivedAction(ctx, result.success)
      }
    },
  })
}
